import type { Language } from '../contexts/RTLContext.js'

/**
 * Returns the appropriate className based on RTL state
 */
export function getRTLClass(ltrClass: string, rtlClass: string, isRTL: boolean): string {
  return isRTL ? rtlClass : ltrClass
}

/**
 * Returns the appropriate message alignment classes based on message type and RTL state
 */
export function getMessageAlignment(isUser: boolean, isRTL: boolean): string {
  if (isUser) {
    // User messages should be opposite to reading direction
    return isRTL ? 'flex-row' : 'flex-row-reverse'
  }
  // AI messages should follow reading direction
  return isRTL ? 'flex-row-reverse' : 'flex-row'
}

/**
 * Returns the appropriate text alignment class based on RTL state
 */
export function getTextAlignment(isRTL: boolean): string {
  return isRTL ? 'text-right' : 'text-left'
}

/**
 * Returns the appropriate flex justify class for content alignment
 */
export function getContentAlignment(isRTL: boolean): string {
  return isRTL ? 'justify-end' : 'justify-start'
}

/**
 * Returns the appropriate margin/padding direction classes
 */
export function getSpacingClass(
  property: 'margin' | 'padding',
  side: 'left' | 'right',
  size: string,
  isRTL: boolean
): string {
  const prefix = property === 'margin' ? 'm' : 'p'
  
  // In RTL, left becomes right and right becomes left
  const actualSide = isRTL ? (side === 'left' ? 'r' : 'l') : (side === 'left' ? 'l' : 'r')
  
  return `${prefix}${actualSide}-${size}`
}

/**
 * Returns localized placeholder text based on language
 */
export function getPlaceholderText(language: Language): string {
  switch (language) {
    case 'heb':
      return 'שאל שאלה על המאמר הזה...'
    case 'arb':
      return 'اسأل سؤالاً عن هذا المقال...'
    case 'eng':
    default:
      return 'Ask a question about this article...'
  }
}

/**
 * Returns the appropriate input direction based on RTL state
 */
export function getInputDirection(isRTL: boolean): 'ltr' | 'rtl' {
  return isRTL ? 'rtl' : 'ltr'
} 